import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const ButtonContent = styled.div`
    justify-content: flex-start;
    align-items: center;
    display: flex;
    width: 100%;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '20px')};
    ${media.mobileDevice`
        justify-content: ${({ isFromReportPymtScreen }) =>
            isFromReportPymtScreen ? 'flex-start' : 'space-between'};
    `}
`;

export const PriceHide = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: 13px;
    letter-spacing: -0.1px;
    cursor: pointer;
    color: #140f4b;
    margin-left: 21px;
    display: ${(props) => (props.isVisible ? 'flex' : 'none')};
    align-items: center;
`;

export const ImageBlock = styled.div`
    margin-bottom: -14px;
`;

export const Buttons = styled.button`
    width: 90px;
    height: 27px;
    cursor: pointer;
    margin: 30px 0px 0px 330px;
    font-size: 13px;
    font-family: AvenirNextWorld Demi;
    color: #ffffff;
    background: #1010eb;
    border: none;
    opacity: 1;
    text-align: center;
    letter-spacing: 0px;
    border-radius: 25px;

    ${media.largeDevice`
        margin:30px 0px 0px 60%;
    `}
    ${media.mediumDevice`
        margin:30px 0px 0px 52%;
    `}
    ${media.smalDevice`
        margin:30px 0px 0px 150px;
    `}
    ${media.mobileDevice`
        margin:0px 0px 0px 0px;
    `}
`;

export const RemovePoText = styled.div`
    font-size: 13px;
    color: #1010eb;
    font-family: AvenirNextWorld Demi;
    cursor: pointer;
    margin-left: 10px;
    ${media.smalDevice`
        margin-right: 5px;
        margin-left: 0px;
    `}
    ${media.mobileDevice`
        text-align:${({ mbTextAlign }) => mbTextAlign};
    `}
`;
